import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m23.5 294.5 152-143.1c4.6-5.2 10.6-7.4 16.5-7.4s11.88 2.188 16.5 6.562l152 143.1c9.625 9.125 10.03 24.31.938 33.93-9.125 9.688-24.38 10.03-33.94.938l-135.5-128.4-135.5 128.4c-9.562 9.094-24.75 8.75-33.94-.938C13.47 318.9 13.87 303.7 23.5 294.5",
      style: {"fill":"var(--fa-primary-color, currentColor)","opacity":"var(--fa-primary-opacity, 1)"}
    }, null, -1)
  ])))
}
export default { render: render }